<template>
    <div class="mask_dia" v-if="show">
        <div class="dia_box guide_padding">
            <b class="close" @click="close"><i class="el-icon-close"></i></b>
            <div class="dia_cnt">
                <h2 v-html="title"></h2>
                <p>
                    请扫码添加微信客服或拨打客服电话400-0186-091为账号充值。
                </p>
                <div class="image_wrap">
                    <img src="@/assets/images/cusQrcode.png" alt="">
                </div>
                <div class="btns">
                    <el-button type="info" @click="handleCancel" v-if="showCancelButton">{{cancelButtonText}}</el-button>
                    <el-button type="primary" @click="handleConfirm" v-if="showConfirmButton">{{confirmButtonText}}</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RechargeBox',
    data () {
        return {
            show: false,
        }
    },
    props: {
        value: {  //父组件使用v-model 默认vue会给子组件传一个名称为value的props
            type: Boolean,
            default: false
        },
        title:{
            type: String,
            default: '充值'
        },
        showConfirmButton:{
            type: Boolean,
            default: true
        },
        showCancelButton:{
            type: Boolean,
            default: false
        },
        confirmButtonText:{
            type: String,
            default: '确认'
        },
        cancelButtonText:{
            type: String,
            default: '取消'
        },
    },
    components: {},
    computed: {},
    watch: {
        value (val) {
            this.show = val;
        },
    },
    created() {},
    mounted() {},
    methods: {
        close () {
            this.$emit('rechargeClose')
            this.$emit('input', false); // 需要关闭组件时，触发input事件 设置父组件 v-model 的 show 为false
        },
        handleConfirm(){
            this.$emit('rechargeConfirm');
        },
        handleCancel(){
            this.$emit('rechargeCancel');
        },
    },
}

</script>
<style scoped lang='less'>
.mask_dia{
    z-index: 999;
    position: fixed;
    background: rgba(0,0,0,.5);
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    overflow-y: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    .dia_box{
        margin:0 auto 20px;
        min-width: 450px;
        padding: 30px 80px;
        box-sizing: border-box;
        background: #fff;
        border-radius: 4px;
        position: relative;
        font-size:14px;
        display: flex;
        justify-content: center;
        .close{
            font-size: 25px;
            color: #fff;
            position: absolute;
            right: -40px;
            top: -20px;
            cursor: pointer;
        }
        .dia_cnt{
            h2{
                text-align: center;
                font-size: 16px;
                font-weight: bold;
            }
            h3{
                font-weight: bold;
                margin-bottom: 15px;
                b{
                    font-weight: bold;
                    font-size:16px;
                    margin:0 3px;
                }
            }
            .image_wrap{
                margin-top: 10px;
                display: flex;
                justify-content: center;
                img{
                    width: 220px;
                }
            }
            .checkBox{
                text-align: left;
                margin-top:10px;
            }
            ul{
                li{
                    margin-bottom:10px;
                    b{
                        font-weight: bold;
                        font-size:16px;
                        margin:0 3px;
                    }
                }
            }
            .btns{
                margin-top:20px;
                display: flex;
                justify-content: center;
                .el-button{
                    width: 200px;
                }
            }
            p{
                text-align: center;
                margin-top: 10px;
                color:#999;
                b{
                    color: #000;
                }
                a{
                    text-decoration: underline;
                    &:hover{
                        color: #6288FB;
                    }
                }
            }
        }
    }
    .guide_padding{
        max-height: 90%;
        padding: 30px 30px;
        .dia_cnt{
            padding-bottom:10px;
            overflow-y:auto
        }
    }
}
</style>